import { createContext, useContext } from "react";

import type { QuickMatchForm } from "~/lib/schemas/quick-match";

export type QuickMatchState = Partial<QuickMatchForm>;

export type QuickMatchContextValue = {
  state: QuickMatchState;
  update: (patch: QuickMatchState) => void;
};

export const QuickMatchContext = createContext<QuickMatchContextValue | null>(
  null,
);

export function useQuickMatchContext(): QuickMatchContextValue {
  const ctx = useContext(QuickMatchContext);
  if (!ctx) {
    throw new Error(
      "useQuickMatchContext must be used within the quick match layout",
    );
  }
  return ctx;
}
